import React from 'react'
import styled from 'react-emotion'

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1170px;
  padding: 0 20px;
`

export default Wrapper



// WEBPACK FOOTER //
// ./src/components/Wrapper/index.js